import styles from "../style";
import brightripplelogo from "../assets/brightripplelogo.png";
import { socialMedia } from "../constants";

const Footer = () => (
  <section className={`${styles.flexCenter} flex-col`}>
    <div className="w-full flex justify-between items-center md:flex-row flex-col pt-6 border-t-[1px] border-t-[#3F3E45]"></div>
    
    <div className="flex justify-between items-center md:flex-row flex-col mb-8 w-full">
   
      <div className="flex flex-col">
       <img src={brightripplelogo} alt="Bright Ripple Logo" className="w-40 h-auto" />
      </div>

      {/* Middle Section - Copyright + Links */}
      <div className="flex flex-col items-center">
        <p className="font-poppins font-normal text-center text-[18px] leading-[27px] text-white mb-2">
         © 2025 Bright Ripple Studios. All Rights Reserved.
        </p>

        {/* ✅ Terms & Privacy Links */}
        <div className="flex flex-row space-x-4">
          <a
            href="/terms-and-conditions-brs.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:underline"
          >
            Terms & Conditions
          </a>
          <span className="text-white">|</span>
          <a
            href="/privacy-policy-brs.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:underline"
          >
            Privacy Policy
          </a>
        </div>
      </div>

      {/* Right Section - Social Icons */}
      <div className="flex flex-row md:mt-0 mt-6">
        {socialMedia.map((social, index) => (
          <img
            key={social.id}
            src={social.icon}
            alt={social.id}
            className={`object-contain cursor-pointer ${
              /* Make Twitter icon slightly larger to match others */
              social.id === "social-media-3" ? "w-[26px] h-[26px]" : "w-[21px] h-[21px]"
            } ${index !== socialMedia.length - 1 ? "mr-6" : "mr-0"}`}
            onClick={() => window.open(social.link)}
          />
        ))}
      </div>
    </div>
  </section>
);

export default Footer;
